import type { TReducerAction } from './actions';
import { ActionTypes } from './actions';
import type { TState } from './state';

export const reducer = (state: TState, action: TReducerAction): TState => {
    switch (action.type) {
        case ActionTypes.ADD_FILTER:
            if (action.payload.filter) {
                return {
                    ...state,
                    [action.payload.route]: {
                        ...state[action.payload.route],
                        [action.payload.filter]: {
                            values: action.payload.values,
                        },
                    },
                };
            }
            return { ...state };
        case ActionTypes.REMOVE_FILTER:
            if (action.payload.filter) {
                return {
                    ...state,
                    [action.payload.route]: {
                        ...state[action.payload.route],
                        [action.payload.filter ?? '']: {
                            values: [],
                        },
                    },
                };
            }
            return { ...state };
        case ActionTypes.UPDATE_FILTERS:
            return {
                ...state,
                [action.payload.route]: {
                    ...action.payload.filters,
                },
            };
        default:
            return state;
    }
};
